import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import './CommunityPublishType.less';


export class CommunityPublishType extends CommonComponent {
  constructor(props) {
    super(props);

    this.state ={
      communityPublishType: {
        show: false,
        communityPublish: {}
      }
    }
  }

  show = (options) => {
    this.setState({
      communityPublishType : options.communityPublishType
    })
  }

  turnToCommunityPublish = (e) => {
    let dataset = Object.assign({},e.currentTarget.dataset, this.data.communityPublishType.communityPublish);
    let publishType = dataset.type === 'link' ? 2 : 0;
    let pageInstance = app.getAppCurrentPage();

    this.setData({
      'communityPublishType.show': false
    });
    pageInstance.communityPublishRef.current.show({
      communityPublish: {
        'show': true,
        'publishType': publishType,
        'detail': dataset.detail || '',
        'articleId': dataset.articleId || '',
        'reqAudit': dataset.reqAudit || '',
        'from': dataset.from || '',
        'franchisee': dataset.franchisee || ''
      }
    })
  }
  returnBack = (e) => {
    this.setData({
      'communityPublishType.show': false
    });
  }


  render(){
    let { communityPublishType } = this.state;
    if(!communityPublishType.show){
      return null;
    }
    return (
      <div className="common-component communityPublishType-wrap">
        <div className="communityPublishType-list">
          <div className="type-default communityPublishType-type" data-type="default" onClick={this.turnToCommunityPublish}>
            <div className="type-image"><img className="image-icon" src="https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/pocket/community_default.png" alt="" /></div>
            <div className="type-text">
              <div className="type-title">图文</div>
              <div className="type-desc">拍照或相册上传</div>
            </div>
          </div>
          <div className="type-link communityPublishType-type" data-type="link" onClick={this.turnToCommunityPublish}>
            <div className="type-image"><img className="image-icon" src="https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/pocket/community_link.png" alt="" /></div>
            <div className="type-text">
              <div className="type-title">文章/链接</div>
              <div className="type-desc">公众号文章或链接</div>
            </div>
          </div>
        </div>
        <div className="return-btn" onClick={this.returnBack}><label className="ico-moon icon-closes"></label></div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/community-publish-type/CommunityPublishType.jsx